module.exports = __webpack_public_path__ + "img/Mask Group 156.43257295.svg";